import React, { useMemo } from "react";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import { summaryColumns } from "../swiming/columns";
import NotAvailable from "components/common/NotAvailable";


const getConfiguration = ({ breakPoint }) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        caption: null,
        sortBy: [],
        columns: [],
    };

    //Only Status
    configuration.caption = undefined;

    configuration.sortBy = [{ id: 'Rank', desc: false }]
    
    configuration.columns = summaryColumns();
      
    configuration.hiddenColumns = [];

    return configuration;
}


const MpnSwimmingSummary = ({ data }) => {
    const items = data?.phaseResults && Array.isArray(data?.phaseResults) && data.phaseResults.length > 0 ? data.phaseResults[0].items : []
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;
    
    const configEvent = useMemo(() => getConfiguration({
        breakPoint: breakPoint
    }), [resultStatus, breakPoint]);

    if (!items) return <NotAvailable />;

    return (
    <>
        <MirsTable
            data={items}
            columns={configEvent.columns}
            keyRow='participant-code'
            caption={configEvent.caption}
            //Columns to hidde 
            hiddenColumns={configEvent.hiddenColumns}
            //When show tble is sorted by 
            initialSortBy={configEvent.sortBy}
            id={`mirs-table-result-${rsc}`}
            //showNavExtendedData={true}
            //hasRelatedTimeline={true}
        />
    </>
);
};

export default MpnSwimmingSummary;
